import React from 'react';
import { graphql } from 'gatsby';
import { useLocation } from '@reach/router';
import './article.scss';
import '../pages/index.scss';
import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown/with-html';
import { ArticlePageQueryInterface } from '../data/StrapiArticle';
import Container from '../components/container';
import { EventDetails } from '../components/featuredEvent';
import twitterIcon from '../assets/twitter.svg';
import linkedInIcon from '../assets/linkedin_article.svg';
import facebookIcon from '../assets/facebook_article.svg';
import Layout from '../components/Layout';
import CtaForArticle from '../components/CtaForArticle';
import SEO from '../components/seo';
import { formatISODateToShort } from '../commons/utils';

export const query = graphql`
  query ArticleQuery($id: Int!) {
    article: strapiArticles(strapiId: { eq: $id }) {
      id
      title
      content
      shortDescription
      publishedOn
      authors {
        name
        twitter_handle
      }
      bannerCover {
        publicURL
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`;

const ArticleLayout: ArticlePageQueryInterface = ({ data: { article } }) => {
  const { pathname } = useLocation();

  return (
    <div>
      <Layout
        dontShowSEO
        description={article.shortDescription}
        coverImage={article.bannerCover.childImageSharp.fluid.src}
        dontShowCTA
        pageTitle={article.title}
      >
        <SEO
          description={article.shortDescription}
          coverImg={article.bannerCover.childImageSharp.fluid.src}
          title={article.title}
          pathname={pathname}
        />
        <Container className="articleContainerPadding">
          <div className="articleContainer">
            <div className="articleContainerMetaData">
              <div>
                <h1>{article.title}</h1>
                <EventDetails details={article.shortDescription} />
                <EventDetails
                  title={
                    <a
                      className="authorDetails"
                      onClick={() =>
                        window.open(
                          `https://twitter.com/${article.authors[0].twitter_handle}`,
                          '_blank',
                        )
                      }
                    >
                      By {article.authors[0].name}{' '}
                      <img src={twitterIcon} height="18px" alt="twitter-icon" />
                    </a>
                  }
                />
                <EventDetails title={formatISODateToShort(article.publishedOn)} />
              </div>
            </div>
            <div className="articleContainerImageContainer">
              {article.bannerCover && <Img fluid={article.bannerCover.childImageSharp.fluid} />}
            </div>
            <div className="articleContainerContent">
              <div className="articleContainerContentShare">
                <div className="articleContainerContentShareContainer">
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        `http://twitter.com/share?text=${article.title}&url=${process.env.GATSBY_TWITTER_URL_PREFIX}${pathname}`,
                        '_blank',
                      )
                    }
                  >
                    <img src={twitterIcon} height="22px" alt="twitter-icon" />
                  </div>
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        `https://www.linkedin.com/shareArticle?url=${process.env.GATSBY_TWITTER_URL_PREFIX}${pathname}&title=${article.title}`,
                        '_blank',
                      )
                    }
                  >
                    <img src={linkedInIcon} height="22px" alt="linkedin-icon" />
                  </div>
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        `http://www.facebook.com/sharer.php?u=${process.env.GATSBY_TWITTER_URL_PREFIX}${pathname}`,
                        '_blank',
                      )
                    }
                  >
                    <img src={facebookIcon} height="22px" alt="facebook-icon" />
                  </div>
                </div>
              </div>
              <div className="articleContainerContentMarkdown">
                <ReactMarkdown escapeHtml={false} source={article.content} />
              </div>
            </div>
            <div className="articleCtaContainer">
              <CtaForArticle />
            </div>
          </div>
        </Container>
      </Layout>
    </div>
  );
};

export default ArticleLayout;
